
import React, { useState, useContext } from 'react';
import axios from 'axios';
import { AuthContext } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent, TextField, Button, Box, Typography } from '@mui/material';

const Login = () => {
    const [formData, setFormData] = useState({
        login: '',
        password: '',
    });
    const [error, setError] = useState(null);

    const { login } = useContext(AuthContext);
    const navigate = useNavigate();

    const { login: loginInput, password } = formData;

    const onChange = e => setFormData({ ...formData, [e.target.name]: e.target.value });

    const onSubmit = async e => {
        e.preventDefault();
        try {
            await login(formData);
            navigate('/');
        } catch (err) {
            setError(err.response.data);
            console.error(err.response.data);
        }
    };

    return (
        <Card sx={{ maxWidth: 400, margin: 'auto', mt: 5 }}>
            <CardContent>
                <h1>Вход</h1>
                <Box component="form" onSubmit={onSubmit} sx={{ mt: 1 }}>
                    {error && (
                        <Typography color="error" variant="body2" sx={{ mb: 2 }}>
                            {error}
                        </Typography>
                    )}
                    <TextField
                        margin="normal"
                        required
                        fullWidth
                        id="login"
                        label="Имя пользователя или Email"
                        name="login"
                        autoComplete="email"
                        autoFocus
                        value={loginInput}
                        onChange={onChange}
                    />
                    <TextField
                        margin="normal"
                        required
                        fullWidth
                        name="password"
                        label="Пароль"
                        type="password"
                        id="password"
                        autoComplete="current-password"
                        value={password}
                        onChange={onChange}
                    />
                    <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        sx={{ mt: 3, mb: 2 }}
                    >
                        Войти
                    </Button>
                </Box>
            </CardContent>
        </Card>
    );
};

export default Login;
